import React from "react";
import { Link } from "react-router-dom";
import './styles/HowItWorks.css';

const HowItWorks = () => {
  return (
    <section className="how-it-works-section">
      <div className="how-it-works-steps">

      <ol className="how-it-works-steps">
        <li className="how-it-works-step">
          <h3><i className="fa-solid fa-cart-shopping" aria-hidden="true"></i><span>Step 1</span></h3>
          <p>Browse our products and add your favorites to the cart. When you're ready, proceed to checkout.</p>
        </li>

        <li className="how-it-works-step">
          <h3><i className="fa-solid fa-lock" aria-hidden="true"></i><span>Step 2</span></h3>
          <p>Complete your purchase <strong>securely</strong> through Stripe. <strong>We never see or store your payment information</strong>.</p>
        </li>

        <li className="how-it-works-step">
          <h3><i className="fa-solid fa-truck-fast" aria-hidden="true"></i><span>Step 3</span></h3>
          <p>Your order is processed and shipped via <strong>USPS, Fedex, or UPS</strong>. Track your package right to your door.</p>
        </li>
      </ol>

      </div>

      {/* ✅ CTA Section */}
      <div className="how-it-works-cta">
        <p>Ready to find the perfect knife for you? Shop our collection of <strong>premium knives</strong> now!</p>
        <Link to="/shop-knives/all-knives" className="cta-button" aria-label="Shop knives now">Shop Now <i className="fa-solid fa-arrow-right"></i></Link>
      </div>

      <p className="how-it-works-footer">
        Have questions? <Link to="/contact">Contact us here</Link>.
      </p>
    </section>
  );
};

export default HowItWorks;
